import React from 'react';
import Features from './Features';
import HowItWorks from './HowItWorks';
import styles from './HomeInfo.module.css';

function HomeInfo() {
  return (
    <div className={styles.root}>
      <Features />
      <HowItWorks />
    </div>
  );
}

export default HomeInfo;
